import { connect } from 'react-redux';

import Component from '../components/js/TopBaseball';
import { ITopStates } from '../store';

const mapStateToProps = (state: ITopStates) => ({
  npb: {
    isShow: state.baseballNpb.isShow,
    games: state.baseballNpb.games,
    date: state.baseballNpb.date
  },
  mlb: {
    isShow: state.baseballMlb.isShow,
    players: state.baseballMlb.players,
    date: state.baseballNpb.date
  }
});

export default connect(mapStateToProps)(Component);
